// Whether dollar amounts are hidden right now (the journal's Privacy display, see display.js).
// Kept free of imports so the money formatters in pnl.js can use it anywhere, including the
// server's prerender of public pages, where it is always off.
let hidden = false;

export function privacyOn() {
  return hidden;
}

export function setPrivacy(on) {
  hidden = on;
}
